import React from "react";

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  color?: "green" | "emerald" | "blue" | "amber";
}

const colorMap = {
  green: "bg-green-100 text-green-600",
  emerald: "bg-emerald-100 text-emerald-600",
  blue: "bg-blue-100 text-blue-600",
  amber: "bg-amber-100 text-amber-600",
};

const StatCard: React.FC<StatCardProps> = ({ icon, label, value, color = "green" }) => (
  <div className="rounded-lg border bg-white shadow-sm border-green-200 p-4 text-center hover:shadow-lg transition-shadow">
    <div className="flex justify-center items-center mb-2">
      <div className={`rounded-full p-2 ${colorMap[color]}`}>{icon}</div>
    </div>
    <p className="text-sm font-medium text-green-800">{label}</p>
    <p className="text-2xl font-bold text-green-900">{value}</p>
  </div>
);

export default StatCard;